module.exports = __webpack_public_path__ + "img/14.11089830.jpg";